import { useAnalytics } from '@/hooks/use-analytics'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'

import { ProductsTable } from './-components/products-table'

interface ProductsSearch {
  search?: string
}

export const Route = createFileRoute('/_authed/_user/products/')({
  // Lets the order-detail panel deep-link to a specific catalog SKU via
  // ``/products?search=<sku>`` and have the search field pre-filled.
  validateSearch: (raw): ProductsSearch => {
    const value = (raw as ProductsSearch).search
    return typeof value === 'string' && value.length > 0 ? { search: value } : {}
  },
  beforeLoad: ({ context }) => {
    if (!context.auth.canUseOrderInbox) {
      throw redirect({ to: '/' })
    }
    return {
      getTitle: () => 'Products',
    }
  },
  component: ProductsPage,
})

function ProductsPage() {
  const { search } = Route.useSearch()
  const { capture } = useAnalytics()
  const viewedRef = useRef(false)

  useEffect(() => {
    if (viewedRef.current)
      return
    viewedRef.current = true
    capture('products_catalog_viewed', { has_url_search: !!search })
  }, [capture, search])

  return <ProductsTable initialSearch={search} />
}
